import { DEFAULT_ROLE_SLUG } from 'consts'
import { ComponentType } from 'react'
import { Container } from 'reactstrap'
import styled from 'styled-components'
import { LinkCard } from 'views/common/link-card'

const Wrapper = styled.div`
  padding-bottom: 240px;
`

const LinkCardWrapper = styled.div`
  padding-bottom: 30px;
`

interface Props {
  categories: any[]
  zone: any
}

export const CategoriesDesktop: ComponentType<Props> = ({ categories, zone }) => (
  <Wrapper>
    <Container>
      <div className="five-row">
        {categories.map((category) => (
          <LinkCardWrapper key={category.uuid} className="five-col-1">
            <LinkCard
              href="/[categorySlug]/[roleSlug]/[zoneSlug]"
              as={`/${category.slug}/${DEFAULT_ROLE_SLUG}/${zone.slug}`}
              title={category.pluralName}
              text={`Ver ${category.properties} ${category.pluralName}`}
              image={category.cover?.thumbnailUrl}
            />
          </LinkCardWrapper>
        ))}
      </div>
    </Container>
  </Wrapper>
)
